// src/lib/taskApi.js
import api from './api'; // Your configured Axios instance

/**
 * Fetches tasks. The backend automatically filters by role.
 * @returns {Promise<Array>} A list of tasks.
 */
export const getTasks = async (page = 1, limit = 10, employeeId = null, keyword = "", status = "", fromDate = "", toDate = "",project_id="") => {
  const params = { page, limit };
  
  if (project_id) params.project_id = project_id;
  if (employeeId) params.employee_id = employeeId;
  if (keyword) params.keyword = keyword;
  if (status) params.status = status;
  if (fromDate) params.startDate = new Date(fromDate).getTime() / 1000; // Convert to Unix timestamp
  if (toDate) params.endDate = new Date(toDate).getTime() / 1000; // Convert to Unix timestamp

  const { data } = await api.get("/tasks", { params });
  
  return {
    tasks: data.data.tasks,
    page: data.data.page,
    pages: data.data.pages,
    total: data.data.total,
  };
};



export const deleteTask = async (taskId) => {
  const { data } = await api.delete(`/tasks/${taskId}`);
  return data;
};

/**
 * Creates a single task (for an employee).
 * @param {Object} newTaskData - The data for the new task.
 * @returns {Promise<Object>} The created task.
 */
export const createBulkTasks = async (newTaskData) => {
  // console.log("📌 Sending bulk tasks payload:", newTaskData);
  const { data } = await api.post("/tasks/bulk", newTaskData); // expects { tasks: [...] }
  return data.data;
};

/**
 * Creates multiple tasks in a single request.
 * Used by both employees and HR.
 * @param {Object} payload - The payload containing tasks and optional employeeProfileId.
 * @returns {Promise<Object>} The API response.
 */
export const createTasks = async (payload) => {
  const { data } = await api.post('/tasks', payload);
  return data.data;
};

/**
 * Updates a task.
 * @param {Object} params - The parameters for the update.
 * @param {string} params.taskId - The ID of the task to update.
 * @param {Object} params.data - The data to update.
 * @returns {Promise<Object>} The updated task data.
 */
export const updateTask = async ({ taskId, data }) => {
  const { data: responseData } = await api.patch(`/tasks/${taskId}`, data);
  return responseData.data;
};

/**
 * Updates multiple tasks at once.
 * @param {Object} payload - The data for the bulk update.
 * @param {string[]} payload.taskIds - An array of task IDs to update.
 * @param {string} payload.status - The new status to apply to all tasks.
 * @returns {Promise<Object>} The API response.
 */
export const bulkUpdateTasks = async (payload) => {
  const { data } = await api.post('/tasks/bulk-update', payload);
  return data.data;
};